import { fromJS } from 'immutable'

const initialState = fromJS({
  formCreator: {
    id: '',
    name: '',
    description: '',
    editingFoG: {
      name: '',
      label: '',
      placeholder: '',
      groupid: '',
      description: '',
      color: ''
    },
    type: '',
    editing: false
  },
  data: [],
  showModalA: false,
  showModalB: false,
  modal: 'A'
})

const formmaker = (state = initialState, action) => {
  switch (action.type) {
    case "FORM_CREATOR_EDIT_FOG":
      return state.merge({
        formCreator: action.payload
      })
    case "FORM_CREATOR_SET_FORM":
      return state.merge({
        formCreator: { ...action.payload }
      })
    case "SET_FORM_VALUES":
      let keys = Object.keys(action.payload), data = []
      keys.forEach(k => {
        data.push({
          name: k,
          value: action.payload[k]
        })
      })
      return state.merge({
        data
      })
    case "CLEAR_FORM_VALUES":
      return state.merge({
        data: []
      })
    case "SHOW_FORM_MODAL_A":
      return state.merge({
        showModalA: action.payload,
        modal: 'A'
      })
    case "SHOW_FORM_MODAL_B":
      return state.merge({
        showModalB: action.payload,
        modal: 'B'
      })
    default:
      return state
  }
}

export default formmaker